import { rgba } from "csx";
import { style } from "typestyle";

export const Colours = {
  primary: "#02ADC3",
  primaryLight: "#AFE2E9",

  textDark: "#637A88",
  textLight: "#A0BCC5",
  textDisabled: "#3e4b60",

  darkestBlue: "#00131F",
  darkerBlue: "#001724",
  darkBlue: "#001D2E",
  blue: "#002438",
  lightBlue: "#002D47",
  lighterBlue: "#003852",
  lightestBlue: "#004D70",

  white: "#F5F5F5",
  purple: "#829CFF",
  darkPurple: "#6245f4",
  nileBlue: "#1C4958",
  orange: "#FF9200",
  yellow: "#EEB902",
  red: "#FF1F41",
  green: "#09EF6E",
};

export const Sizes = {
  small: "1.5rem",
  halfSmall: ".78571429rem",
  maxWidth: 1800,
  height: "50px",
  container: 1024,
  fontSize1: 12.5,
  fontSize2: 15,
  fontSize3: 20,
  fontSize4: 25,
  lineHeight: 1.5,
  input: 375,
  borderRadius: 5,
};

export const fontFamily = "'Open Sans', sans-serif";
export const boxShadow = "0 5px 10px " + rgba(0, 0, 0, 0.4).toString();

export enum zIndex {
  highest = 1000,
  high = 100,
  normal = 1,
  base = 0,
}

export const scrollClass = style({
  overflow: "hidden",
  $nest: {
    "&:hover": {
      overflow: "overlay",
    },
  },
});
